<template>
    <div class="items-wrap">
        <div
            class="items marquee"
            :class="{ reverce: reverse }"
            @mouseover="stopScroll"
            @mouseleave="resumeScroll"
        >
            <div
                v-for="(src, index) in shiftedIds"
                :key="index"
                class="item brand_img"
            >
                <img
                    :src="src"
                    alt="partner logo"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'MarqueeRow',
    props: {
        ids: {
            type: Array,
            required: true,
        },
        reverse: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        shiftedIds () {
            if (this.ids.length < 2) return [...this.ids, ...this.ids]; // safety
            const firstPart = this.ids.slice(1);
            const shifted = firstPart.concat(this.ids.slice(0, 1));

            return [...this.ids, ...shifted];
        },
    },
    methods: {
        stopScroll () {
            const el = this.$el.querySelector('.items');

            if (el) el.style.animationPlayState = 'paused';
        },
        resumeScroll () {
            const el = this.$el.querySelector('.items');

            if (el) el.style.animationPlayState = 'running';
        },
    },
});
</script>

<style scoped>
.item img {
  max-height: 140px;
  border-radius: 1rem; /* можешь настроить под размер */
  transition: 0.2s ease;
}
.item img:hover {
border: 1px solid black;
transition: 0.2s ease;
}
</style>
